module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "sz"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "sz"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "sz"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p9"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b', [_vm._v("Chapter 1")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "alt": "flourish",
      "src": "images/flourish.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "sz"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('i', [_vm._v("Spring City, Colorado")])])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The train rocked sharply to the left and Sophie smacked her head against the window for the umpteenth time that day. "), _c('i', [_vm._v("Really!")]), _vm._v(" She rubbed her temple, running her hand over her dark hair. This was certainly not the smooth ride between New York and Boston, or even between Paris and Rome, for that matter. This was the West. This was freedom, she thought to herself with the merest hint of a smile.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("As the train crossed over into Colorado, heading for tiny Spring City, none of the other passengers would suspect she was anyone out of the ordinary. Looking at her, in her well-appointed blue dress, her hands folded in her lap, no one would know or care that she was a world-class pianist. Her studies at The Boston Conservatory of Music under its famed director Julius Eichberg and then at The National Academy of St. Cecilia in Rome were of little use to her at that moment.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Sophie stretched delicately before turning her face once again to the window. Briefly, she caught sight of her own reflection. Although the man she'd believed she would marry had torn her heart asunder the previous year, destroying her composure with all the roughness of a piano's dissonant second interval, she decided her appearance was unchanged.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Well, perhaps a bit weary-looking around her eyes, which stared solemnly back at her. On the inside, however, Sophie struggled to regain the self-possession she'd felt before Philip went to Oxford University to study philosophy—without her.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('i', [_vm._v("What was the point")]), _vm._v(", she had wondered aloud to him, "), _c('i', [_vm._v("to debate life and God and Heaven and whatnot?")]), _vm._v(" When she played her pianoforte, she knew the meaning of life. And she even suspected she'd heard the sounds of Heaven in many a concerto. "), _c('i', [_vm._v("Why debate and deliberate? Why not just live life and be grateful?")])])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Philip had not invited her to Oxford, and she'd left Rome alone, returning home to Boston.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She focused on the vastness outside the train, feeling a little disappointed at having seen so few buffalo. No great herds were left. Her sister-in-law, Charlotte, who had lived in Colorado until she'd met Sophie's brother nearly a year and a half earlier, had told her about the wide open spaces. Sophie had never seen the magnificent open plains before, and, in that respect, she had not been disappointed.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("However, she had to admit that each time the train pulled into a station, no matter how small the pocket of civilization, she would breathe a sigh of relief. And when the long sequence of passenger cars, sleeper car, dining car, and baggage car, all pulled by a strong locomotive and guarded at the rear by the caboose, left a town behind and wound its way farther across the deserted prairie, anxiety gripped her anew. She felt as though she were on a tiny boat in a nearly limitless ocean.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("When she finally arrived in Spring City, Colorado, Sophie stood on the station platform, looking expectantly for Dr. Cuthins and his wife; Doc and Sarah were old friends of Charlotte, who was now the toast of Boston's literary society and Sophie's brother's adored bride. They had attended her wedding in Boston the year before. Having them there, representing Spring City, had been a generous gift to Charlotte. Sophie's gift to her brother, Reed, and her new sister-in-law was an original composition, which she played at the reception hall while they danced.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("After the wedding, she'd waited patiently through the long winter that turned into spring and then the insufferably hot months for their first baby to be born. At last, she made her escape from Boston's smothering atmosphere in early August.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("And here she stood, thousands of miles from home.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Sophie waited and waited, until the train had departed and the platform was empty. She was thirsty. Offering—no, insisting—on handling the task of packing up Charlotte's things had seemed a brilliant idea a few months ago. Despite her own brother's hesitation over her safety and despite Charlotte's brother's offer to complete the task himself, Sophie had claimed the job; she'd dismissed Reed's concerns and then pointed out Thaddeus's lack of reliability—Charlotte's brother was still a bit of an unknown entity, who never stayed in one place very long. It was the perfect excuse for Sophie to get away, see the west, and forget Philip. Or at least, she would try to.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She sat down on her trunk, her carpet bag on her lap and wondered what she should do. This was not Boston. No cabriolets happened by to take stranded passengers to their destinations.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She sighed. It was not the first time she'd found herself either alone or stranded, or both, in a strange city. But this was the first time she'd seen a mule pass by, looking as if it were more composed than she, in fact, felt. Now that she was off the train, the big open space all around the small town seemed even bigger, and the town, itself, seemed to shrink, becoming the littlest oasis in a massive landscape.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Humming to herself, she jiggled her leg, checked the pins holding her hat, and desperately wished for a cafe offering some strong Turkish brew and a pastry.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Just then a strange noise took her attention to the sky; an ugly black bird with a small head and large black body was cruising lazily back and forth, making a warbled bark. She shuddered. This was the \"wild west,\" indeed, as Thomas Reid had described it, and not for the first time, she wished she hadn't read her younger sister's copy of "), _c('i', [_vm._v("The Scalp Hunters")]), _vm._v(" before traveling.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("So, what to do? Obviously, there was no telephone nearby, and a telegraph office wouldn't help her now. Even the ticket window was closed and shuttered.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("With resolve, Sophie half pushed, half dragged her trunk until it landed in the dirt next to the platform. She took the two steps down to street level and grabbed the handle. Luckily, having traveled extensively, she was not one to over pack. Still, it was a struggle as she resorted to pulling the trunk along the dusty road with her carpet bag perched on top.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Spring City was not big by any standard, and the station was at one end of the town, but which end was Charlotte's home? That, Sophie did not know.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Main Street\" stated the sign, as she approached the first block of buildings and she paused. It had to be a joke as she saw no other streets at all. But on the horizon were mountains, grand, even awe-inspiring. She shivered despite the heat of the day and the difficult task at hand. She really was on the edge of nowhere.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("All the buildings looked similar, with flat fronts and squared off tops, though she could see behind the frontage that the roofs were slanted as any in the east. Some had a second story, with two windows over two, but that was the highest she saw. No wonder her sister-in-law had walked Boston's streets staring up at the buildings for months after she'd arrived.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Sophie had no idea a town could still look so... so primitive in this day and age. She saw no brick at all, only wood, even the sidewalks were wood, raised up a step from street level.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Along the sidewalk was the occasional barrel, a trough, or a hitching post. Wagons were parked and horses pawed at the road that bisected the town before stretching, it seemed, all the way to the mountains in the distance. And, of course, there were people—not a lot, but some sitting on benches in front of stores, some standing in doorways. And every one of them turned to look at Sophie.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She knew what she needed to find, either Fuller's Hotel and Restaurant or Doc Cuthins' surgery. She had to locate the people whom Charlotte considered friends and whom Sophie could ask for help. She dragged her trunk a few more yards, wishing she could set it down and walk briskly along unhampered, but she feared everything she'd brought would disappear in the blink of an eye.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("With almost all the strength gone in her arms, she was attempting to heave the trunk up onto the sidewalk, perching one end on the wooden planks, when someone collided with her from the rear.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Oomph,\" she expelled all the air from her lungs as her stomach caught on the tilted edge of her trunk, then she slid slowly down the length of it back onto the dirt road, head and hands first. For a dreadful moment, she sprawled there, knowing her dress was up at her waist and her drawers, lavender-colored and lacy, were on view.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Shit,\" she heard before she could right herself. The man's sentiment echoed what was in her head, though she was too much of a lady to voice it. And then, \"Oh, Jesus, ma'am\" as strong arms lifted her off the ground.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Sophie was not one to take offense, though she was getting sorely tired. Anything she was about to say, however, died on her lips at the spectacle of the man who now had hold of her.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("To compose herself, she looked down to see what had happened to her things—her carpet bag was upended in the street—then she looked back to the man's mud-splattered boots, up his worn, fitting blue jeans, and to what had once been a pale blue shirt now covered in grime.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Her gaze traveled higher to his equally grubby but ridiculously handsome face that had stopped her cold for a moment, with his burnished brown eyes, dark eye lashes, and inviting mouth that curved as though it tended to smile often.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He tipped his black brim to her, with a quick tap of his hand.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Ma'am,\" he said and gave her a brief smile that showed a dimple in his right cheek, his teeth looking all the whiter for appearing in the midst of his dirty face. Dirty and devastatingly attractive—a combination she hadn't experienced before.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He was tall, clearly, for she had to look up to him, despite her own uncommon height, at least for a woman. And she realized he was still holding her arm with one hand, a strong capable hand. She felt his warmth right through the fabric of her dress and her mantle.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Letting herself feel his fingers gripping her for a moment more, she then shook him off by taking one step back.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Are you all right?\" he asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Sophie looked at her hands, stretching them in front of her and wriggling her fingers. Everything seemed fine except for her white gloves being torn and filthy.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I'm fine,\" she said at last, seeing as he was watching her careful examination. \"I'm sorry. I wasn't looking where I was going.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Me neither,\" he offered. \"I was talking to Dan and walking out of Drew's.\" He gestured to the feed store. A man standing in the doorway, wearing a heavy apron, chuckled.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Yup, he was,\" Dan confirmed. \"Riley, don't you know better than to leave a store ass first? Unless you're trying to drum up future business for yourself.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Riley laughed and looked back at Sophie, who tamped down the inappropriate notion that he had a very sweet, even sexy laugh and that his eyes sparkled wickedly when he was amused.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Most women would have given me a tongue lashing for knocking them into the street and ruining their gloves.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"As long as you don't make a habit of it,\" she said, glad that she hadn't been in Boston, where she would have been run over by a brougham within seconds.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I'll try not to.\" He treated her to a broad grin—a very sensual grin, too, Sophie mused. "), _c('i', [_vm._v("She must be very tired and lonely to keep having these incorrigible thoughts.")])])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Can I make it up to you?\" he asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Without waiting for an answer, he lifted up her traveling trunk as though it weighed nothing and deposited it on the sidewalk in front of the feed store.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She retrieved her carpet bag from the street and stepped up beside him.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Thank you. Can you tell me how to get to Fuller's? Or better yet, to Dr. Cuthins?\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Well, which do you need?\" He crossed his arms. \"A place to stay or a doctor?\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Riley could give you either one,\" Dan said, before turning and going back inside, as Riley dismissed him with a wave of his hand.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Neither, really,\" Sophie said, ignoring the man's remark, \"but Dr. Cuthins was supposed to meet me at the train, with his wife.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Maybe he had an emergency,\" Riley said. \"Though I'm sure Sarah would've come herself.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"It could be they didn't receive my last telegram with the correct date of my arrival,\" Sophie suggested. \"If you direct me to Fuller's, I'll—\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I'll do even better,\" he said. \"Follow me.\" And with that, he heaved the trunk up onto his shoulder and started along the sidewalk, Sophie trailing behind.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Are you kin? To Doc or Sarah, I mean.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"No,\" Sophie said, not wanting to elaborate on her personal life. It was bad enough that a strange man was carrying her luggage and had most likely seen her drawers.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I didn't get your name,\" he said over his shoulder.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"No, you didn't,\" Sophie said, unused to the familiarity. He hesitated and she nearly ran into the back of him. Then he resumed his easy saunter.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"You're not from here?\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Obviously,\" Sophie agreed.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Hey, Riley,\" came a voice from the next shop they passed, a barber standing in the doorway, arms crossed.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Hey, Ely,\" Riley said without stopping.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Sophie nodded to the man who gave her a long friendly look as she passed by before he called out, \"Riley, you-know-who's gonna be hopping mad.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Riley just flapped his free hand back at Ely, either to acknowledge or dismiss the sentiment. A jealous wife, perhaps, Sophie mused.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I've been away for a while,\" Riley continued their conversation, \"but I still would have remembered you.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Sophie supposed some women might have simpered or blushed, but she merely shrugged. \"It's a small town. I'm sure if I'd grown up here, we would have run into each other.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Then she did run into him, as all of his six feet and two or three inches came to an abrupt halt.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Why have we stopped?\" she asked, touching her nose where it had collided with the back of his shirt and trying to peer up at her own bonnet to see if the brim had been utterly crushed against his broad back. He lowered the trunk to the sidewalk.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Doc's place,\" Riley said, gesturing at the white door in the one-story building.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She looked up to see a shingle that had 'Cuthins, Physician' in plain black lettering on a painted white sign. Riley opened the door for her and stepped aside.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Why, thank you, Mr.... ah?\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Dalcourt, but you can call me Riley.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Thank you, Riley.\" It felt strange, indeed, to call this man by his first name, but she didn't want to seem stuck up. He still held the door, so she went in. She scanned the tidy waiting room and noted a door in the back wall, probably leading to the examination room and surgery.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Sitting at a desk was a middle-aged woman, dressed in pale gingham, with glasses perched on her nose, perusing papers.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Sarah, you have company.\" She looked up at Riley's voice.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Oh, my word! Sophie!\" Sarah came out from behind the desk. \"But how can you be here today?\" She took Sophie's bag without asking and set it down on a chair. \"Gracious, I forgot how much you are the spitting image of your brother.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Sophie winced slightly. With her striking height, dark hair and vivid blue-black eyes, she knew she looked a lot like Reed, only she hoped a tad more feminine.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Mrs. Cuthins, I fear you didn't get my last telegram.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Please, call me Sarah,\" she said, coming forward to hug Sophie, who stiffened. Right then, the inner door opened and Doc Cuthins emerged.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Sarah laughed and released Sophie. \"I forgot. You Easterners aren't quite as relaxed and friendly as we are.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Stop teasing the girl,\" Doc Cuthins said to his wife. \"Not everyone wants to immediately be your kissing cousin. Now, where are your things, Sophie?\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Mr.... ah... that is, Riley, has my trunk,\" Sophie said and turned to see that he'd already stepped back outside and was loading her trunk into a wagon.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Oh, I—\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"That's our trap,\" Sarah reassured her. \"I'm gonna get this girl home and fed, lickety split,\" she told her husband. \"I'll see you later.\" And she placed a big kiss on Doc's lips, leaving him with a smile, before she ushered Sophie back through the door.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("On the sidewalk again , Sophie turned to Riley.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I appreciate your help.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Anytime, Sophie,\" he said, shooting her a grin, evidently pleased at having gained this piece of personal information. With another tip of his hat, he walked back along the way they'd come. She watched him a moment before getting up into the wagon next to Sarah, unable to completely tamp down a vague happy feeling at having met him. Perhaps she would even admit to a flutter of excitement.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Charlotte's house is ready for you. I've made up the bed but I haven't stocked the pantry,\" Sarah fussed as they drove along Main Street.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Sophie had heard of Sarah's fervent desire to feed every stray soul who came through Spring City or who had the poor sense not to cook, like Charlotte.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I'm sure I can come up with something,\" Sophie said. \"If you drop me off at Charlotte's—\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Nonsense, we'll stop at my house for a cup of tea while I pack you up some home cooking, then when Doc gets home, we'll take you over. And we'll bring Alfred along, too.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Alfred?\" Sophie repeated; for some reason, her mind went to Riley Dalcourt, as if somehow Sarah was going to produce a man for Sophie to borrow as well.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Charlotte's old horse. He's been great company to my Bonnie here, but you can use him to get back and forth.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"That's very kind, Sarah, but I won't be here very long.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Long enough to need a horse and wagon, I'm sure,\" Sarah said, ending the discussion and turning instead to questions about Charlotte and Reed and their new baby.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("It hadn't been more than a few minutes when Sarah said, \"We're here,\" and turned the trap into the small yard of a neat little house, all white and blue, with flowers everywhere. Before she could say another word, a horse went galloping by.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Purple!\" came an exuberant voice that trailed after the rider. Both the women turned to see man and horse already yards away, a black hat raised high in the air in salutation.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Riley!\" declared Sarah, with a chuckle. \"What in the heck is he saying?\" But Sophie had gone quite still for she had the nasty feeling he was referring to her undergarments.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("* * *")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Riley continued riding far into the foothills. He urged his horse faster until they were both breathing hard, and finally he pulled back on the reins. Turning his mount, he regarded Spring City and could make out the Sanborn house where Sophie was staying. He didn't even know the woman's last name.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He spat into the long grass to get the grit out of his mouth and spurred his horse homeward. It didn't matter anyway. So what that he had pictured a woman like her, back when he was a younger, more idealistic man. A woman with dark hair and intelligent eyes, full pink lips and a tall curvaceous body. Reality had a way of chasing off frivolous dreams, or outright killing them. He "), _c('i', [_vm._v("had")]), _vm._v(" a fiancée, a good woman to whom he'd promised himself, body and soul.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23c79263","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section6.vue
// module id = 72
// module chunks = 0